import generalConfig from './general';

/**
 * Preinscripción de renovación (CU-86961ve0z): en producción no se ofrece
 * todavía, mientras producto valida la funcionalidad en PRE. Oculta las dos
 * únicas puertas de entrada —la casilla al duplicar y el bloque de fechas del
 * detalle—, así que en PRO ninguna actividad puede quedar armada y el resto del
 * flujo no llega a activarse. También oculta la nota que el diálogo de alta de
 * alumno muestra durante la ventana (CU-869f643fv).
 *
 * El interruptor es el entorno de despliegue, no el plan del centro: llega en
 * el `runtimeConfig` que monta Argo CD (`environment: 'PRO'` en producción,
 * `'PRE'` en preproducción). Un valor desconocido cuenta como producción, que es
 * lo que hace `generalConfig`, así que el fallo seguro es esconderla.
 *
 * Para publicarla: borrar esta función y todos sus usos.
 */
export function isRenewalPreenrollmentVisible(): boolean {
    return generalConfig.environment !== 'PRO';
}

/**
 * Reubicación automática de alumnos (CU-869ezdgnr): oculta en producción igual
 * que la preinscripción, con la que se valida. Solo esconde la casilla al
 * duplicar; la pestaña de una copia que ya se reubicó se sigue viendo.
 *
 * Para publicarla: borrar esta función y su uso.
 */
export function isStudentRelocationVisible(): boolean {
    return generalConfig.environment !== 'PRO';
}
